import './style.scss';

import React from 'react';
import LoadingSpinner from '../loadingSpinner';
import { baseClasses as getTextClasses } from '../text';

function Button(props) {
  return (
    <button
      type={props.type}
      disabled={props.disabled}
      className={getClassName(props)}
      onClick={props.onClick}
    >
      {props.loading ? <LoadingSpinner inline /> : props.children}
    </button>
  );
}

function getClassName({
  className,
  loading,
  primary,
  secondary,
  outline,
  fullWidth,
  raised,
  round,
  rect,
  margin,
  textStyles
}) {
  return []
    .concat(className ? className : '')
    .concat(loading ? 'button--loading' : '')
    .concat(primary ? 'button--primary' : '')
    .concat(secondary ? 'button--secondary' : '')
    .concat(outline ? 'button--outline' : '')
    .concat(fullWidth ? 'button--full-width' : '')
    .concat(raised ? 'button--raised' : '')
    .concat(round ? 'button--round' : '')
    .concat(rect ? 'button--rect' : '')
    .concat(margin === 'none' ? 'button--no-margin' : '')
    .concat(textStyles ? getTextClasses(textStyles) : [])
    .filter(c => !!c)
    .join(' ');
}

export default Button;



// WEBPACK FOOTER //
// ./shared/components/ui/button/index.js